// from https://dev.to/rodw1995/cancel-your-promises-when-a-component-unmounts-gkl
import { useCallback, useRef } from "react";
import { useMount } from "constants/constants";

/**
 * TECHDEBT: for less ambiguity, rename to useGetIsUnmounted & switch true / false
 *
 * tracks if a component has been unmounted
 * (handy for cancelling subscriptions)
 *
 * usage:
 * const getIsMounted = useGetIsMounted()
 *
 * if(getIsMounted()) { setState here... }
 *
 * @returns {() => boolean}
 */
export default function useGetIsMounted(): () => boolean {
  const mountedRef = useRef<boolean>(true);

  // useMount is a useEffect with no dependencies, so it only runs once, on mount
  useMount(() => {
    return () => {
      // The cleanup function of useEffect is called by React on unmount
      mountedRef.current = false;
    };
  });

  // we return a useCallback (a memoized function) to avoid
  // causing re-renders when the mountedRef.current changes
  return useCallback(() => mountedRef.current, []);
}
